import React, { useEffect, createElement } from 'react';
// =============================================
// INSTRUCCIONES PARA CONFIGURAR TU PIXEL:
//
// 1. Andá a https://business.facebook.com/events_manager
// 2. Seleccioná tu Pixel (o creá uno nuevo)
// 3. Copiá tu PIXEL ID (es un número largo, ej: 123456789012345)
// 4. Reemplazá 'TU_PIXEL_ID_AQUI' abajo con tu ID real
// =============================================
const FB_PIXEL_ID = '1398995631816434';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (FB_PIXEL_ID === 'TU_PIXEL_ID_AQUI') {
      console.warn('[MetaPixel] Configurá tu Pixel ID en components/MetaPixel.tsx');
      return;
    }
    // Inicializar fbq
    const f: any = window;
    const b = document;
    const e = 'script';
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = b.getElementsByTagName(e)[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', FB_PIXEL_ID);
    window.fbq('track', 'PageView');
    // Noscript fallback
    const noscript = document.createElement('img');
    noscript.height = 1;
    noscript.width = 1;
    noscript.style.display = 'none';
    noscript.src = `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`;
    document.body.appendChild(noscript);
    return () => {
      if (noscript.parentNode) {
        noscript.parentNode.removeChild(noscript);
      }
    };
  }, []);
  return null;
}